import { ApiResponse } from "@src/types/httpApi";
import { IPlaylistRecommendationTag } from "@src/types/playlistRecommendationTag";
import httpApi from "@src/utils/httpApi";
import { AxiosResponse } from "axios";

export const fetchPlaylistRecommendationTagsApi = async ({
  searchText,
  page = 1,
  pageSize = 50,
}: {
  searchText?: string;
  page?: number;
  pageSize?: number;
}): Promise<AxiosResponse<ApiResponse<IPlaylistRecommendationTag[]>>> => {
  const queryParams = new URLSearchParams();
  if (searchText) {
    queryParams.append(
      "filters[title][$containsi]",
      String(searchText).toLowerCase().trim()
    );
  }
  queryParams.append("pagination[page]", String(page));
  queryParams.append("pagination[pageSize]", String(pageSize));
  return httpApi.get(
    `/api/playlist-recommendation-tags?${queryParams.toString()}`
  );
};

export const createPlaylistRecommendationTagApi = async ({
  title,
}: {
  title: string;
}): Promise<AxiosResponse<ApiResponse<IPlaylistRecommendationTag>>> => {
  return httpApi.post(`/api/playlist-recommendation-tags`, { data: { title } });
};
